import type { LicenseCriteria } from '../../types'

interface CriteriaStatsSummaryProps {
  criteria: LicenseCriteria[]
}

interface StatCardProps {
  label: string
  value: string
  valueClass?: string
}

function StatCard({ label, value, valueClass }: StatCardProps): React.ReactElement {
  const finalValueClass = valueClass ?? 'text-stone-900 dark:text-stone-100'
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-4 dark:border-stone-700 dark:bg-stone-800">
      <p className="text-sm text-stone-500 dark:text-stone-400">{label}</p>
      <p className={`text-2xl font-semibold ${finalValueClass}`}>{value}</p>
    </div>
  )
}

export function CriteriaStatsSummary({ criteria }: CriteriaStatsSummaryProps): React.ReactElement {
  const pendingCount = criteria.filter((entry) => entry.status === 'pending').length
  const verifiedCount = criteria.filter((entry) => entry.status === 'verified').length
  const invalidCount = criteria.filter((entry) => entry.status === 'invalid').length
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      <StatCard label="Total Criteria" value={String(criteria.length)} />
      <StatCard
        label="Pending"
        value={String(pendingCount)}
        valueClass="text-amber-600 dark:text-amber-400"
      />
      <StatCard
        label="Verified"
        value={String(verifiedCount)}
        valueClass="text-green-600 dark:text-green-400"
      />
      <StatCard
        label="Invalid"
        value={String(invalidCount)}
        valueClass="text-red-600 dark:text-red-400"
      />
    </div>
  )
}
